import type { MouseEvent } from 'react';
import { Button, Tooltip } from '@mui/material';
import { useHasPermission } from '../PermissionGate';
import { useFeature } from '../featureFlags/FeatureGate';
import { FEATURE_ASSIGN_BUTTON_FOR_PLANNER, TEAM_LEADER_ASSIGNS_HINT } from './variantValidity';

/**
 * „Obsadź” u planisty — nieaktywny, z podpowiedzią, że obsadza Team Leader
 * (makieta back office v2, BR-FTL-01, ścieżka FTL-02 krok 1; decyzja
 * użytkownika 20.10.2026, D1; przełącznik `assignButtonForPlanner`).
 *
 * Wyjątek od zasady z 01.10.2026 („funkcje bez uprawnień są ukryte, nie
 * wyszarzone”) — tylko dla tego jednego przycisku i tylko dla roli, która
 * planuje (`FTL_PLANNING`), a nie obsadza (`FTL_ASSIGN`): planista ma
 * widzieć, że decyzja jest u Team Leadera. Trader, gość i reszta — bez
 * zmian (przycisku nie ma). Uprawnienia nie daje: API odmawia 403.
 */
export function usePlannerSeesDisabledAssign(): boolean {
  const on = useFeature(FEATURE_ASSIGN_BUTTON_FOR_PLANNER);
  const canPlan = useHasPermission('FTL_PLANNING');
  const canAssign = useHasPermission('FTL_ASSIGN');
  return on && canPlan && !canAssign;
}

const stop = (e: MouseEvent) => e.stopPropagation();

/** Nieaktywny „Obsadź” z podpowiedzią — owijka, bo zablokowany przycisk nie pokazuje dymka. */
export const TeamLeaderAssignsButton = ({
  label = 'Obsadź',
  variant = 'contained',
}: {
  label?: string;
  variant?: 'contained' | 'outlined';
}) => (
  <Tooltip title={TEAM_LEADER_ASSIGNS_HINT} describeChild placement="top">
    <span onClick={stop} data-testid="assign-team-leader-only">
      {/* Kontrakt `data-testid` paczki (S-22.10-02): zablokowane „Obsadź”; `data-tip` — treść dymka
          dla sprawdzenia „podpowiedź” (dymek MUI rysuje się dopiero po najechaniu). */}
      <Button
        size="small"
        variant={variant}
        disableElevation
        disabled
        sx={{ whiteSpace: 'nowrap', ...(variant === 'outlined' ? { py: 0, minWidth: 0 } : {}) }}
        data-testid="ftl-zlecenie-obsadz-blokada"
        data-tip={TEAM_LEADER_ASSIGNS_HINT}
      >
        {label}
      </Button>
    </span>
  </Tooltip>
);
